"use strict";
module.exports = BufferReader;

/*             */
var Reader = require("./reader");
(BufferReader.prototype = Object.create(Reader.prototype)).constructor = BufferReader;

var util = require("./util/minimal");

/**
 *
 *
 *
 *
 *
 */
function BufferReader(buffer) {
    Reader.call(this, buffer);

    /**
 *
 *
 *
 */
}

BufferReader._configure = function () {
    /*                      */
    if (util.Buffer)
        BufferReader.prototype._slice = util.Buffer.prototype.slice;
};


/**
 *
 */
BufferReader.prototype.string = function read_string_buffer() {
    var len = this.uint32(); /*           */
    return this.buf.utf8Slice
        ? this.buf.utf8Slice(this.pos, this.pos = Math.min(this.pos + len, this.len))
        : this.buf.toString("utf-8", this.pos, this.pos = Math.min(this.pos + len, this.len));
};

/**
 *
 *
 *
 *
 */

BufferReader._configure();
